module.exports = __webpack_public_path__ + "img/29.80b25ae8.jpg";